import { CircularProgress, Flex, Text } from "@chakra-ui/react"
import React from "react"
import { useTranslation } from "react-i18next"

interface Props {}

const CloudBrowserImportOverlay: React.FC<Props> = () => {
  const { t } = useTranslation()

  return (
    <Flex
      position="absolute"
      flexDirection="column"
      top={0}
      left={0}
      right={0}
      bottom={0}
      gap={3}
      backgroundColor="whiteAlpha.800"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress isIndeterminate color="primary.600" size="80px" />
      <Text fontWeight="bold">
        {t(
          "components.cloudProvider.common.CloudBrowserImportOverlay.Importing"
        )}
      </Text>
    </Flex>
  )
}

export default CloudBrowserImportOverlay
